import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "errorpage",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }
const _hoisted_3 = { class: "description text-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]

import {useGlobalStore} from "@/stores/GlobalStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'PageNotFound',
  setup(__props) {

const globalStore = useGlobalStore();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("404.headline")), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("404.subline")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.$t('404.description')
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        (_unref(globalStore).userPreferences.userStartPage != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: _unref(globalStore).userPreferences.userStartPage
              }, {
                default: _withCtx(({href, route, navigate}) => [
                  _createElementVNode("button", {
                    href: href,
                    onClick: navigate,
                    class: "btn primary"
                  }, _toDisplayString(_ctx.$t("404.buttonText")) + " (" + _toDisplayString(route.name) + ") ", 9, _hoisted_6)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/login" }, {
                default: _withCtx(({navigate}) => [
                  _createElementVNode("button", {
                    onClick: navigate,
                    class: "btn primary"
                  }, _toDisplayString(_ctx.$t("404.buttonLogin")), 9, _hoisted_8)
                ]),
                _: 1
              })
            ]))
      ])
    ])
  ]))
}
}

})